var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function (n) { return (_pushScopeId("data-v-f82bf166"), n = n(), _popScopeId(), n); };
var _hoisted_1 = { class: "flex space-x-2" };
import { computed, nextTick, onMounted, ref, toRefs } from 'vue';
import { useAudioControls } from '@common/hooks/audio/useAudioControls';
export default /*#__PURE__*/ _defineComponent({
    __name: 'EAudioPlayer',
    props: {
        audio: {},
        averageFrequency: {},
        barWidth: { default: 3 },
        barOffset: { default: 2 }
    },
    setup: function (__props, _a) {
        var _this = this;
        var __expose = _a.expose;
        var props = __props;
        var audioPlayerRef = ref();
        var audioControls = useAudioControls({
            audio: props.audio,
            averageFrequency: props.averageFrequency
        });
        var toggleRecord = audioControls.toggleRecord, changeCurrentTime = audioControls.changeCurrentTime, renderPlayer = audioControls.renderPlayer, toggleRate = audioControls.toggleRate;
        var playbackRate = toRefs(audioControls).playbackRate;
        var isRecordPlay = computed(function () { return audioControls.isRecordPlay.value; });
        var barsWithPercentage = computed(function () { return audioControls.barsWithPercentage.value; });
        var currentTimeFormat = computed(function () { return audioControls.currentTimeFormat.value; });
        onMounted(function () {
            nextTick(function () { return __awaiter(_this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    if (!audioPlayerRef.value || !props.audio) {
                        return [2 /*return*/];
                    }
                    renderPlayer(audioPlayerRef.value, props.barWidth, props.barOffset);
                    return [2 /*return*/];
                });
            }); });
        });
        var dragTrack = function (mouseEvent) { return __awaiter(_this, void 0, void 0, function () {
            var rect, widthTrack, onePercentage, progressPercent;
            var _a;
            return __generator(this, function (_b) {
                rect = (_a = audioPlayerRef.value) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect();
                if (!rect)
                    return [2 /*return*/];
                widthTrack = rect.right - rect.left;
                onePercentage = widthTrack / 100;
                progressPercent = (mouseEvent.clientX - rect.left) / onePercentage;
                changeCurrentTime(progressPercent);
                return [2 /*return*/];
            });
        }); };
        var onMouseDown = function (mouseEvent) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, dragTrack(mouseEvent)];
                    case 1:
                        _a.sent();
                        document.addEventListener('mousemove', mouseMove);
                        document.addEventListener('mouseup', mouseUp);
                        return [2 /*return*/];
                }
            });
        }); };
        var mouseMove = function (mouseEvent) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, dragTrack(mouseEvent)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); };
        var mouseUp = function () {
            document.removeEventListener('mouseup', mouseUp);
            document.removeEventListener('mousemove', mouseMove);
        };
        __expose({
            isRecordPlay: isRecordPlay,
            toggleRecord: toggleRecord,
            currentTimeFormat: currentTimeFormat,
        });
        return function (_ctx, _cache) {
            var _component_e_icon = _resolveComponent("e-icon");
            var _component_e_button = _resolveComponent("e-button");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", {
                    ref_key: "audioPlayerRef",
                    ref: audioPlayerRef,
                    class: "player",
                    onMousedown: onMouseDown
                }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(barsWithPercentage.value, function (barPercentage, index) {
                        return (_openBlock(), _createElementBlock("div", {
                            key: index,
                            class: _normalizeClass([[barPercentage.isHeard ? 'active-bar' : ''], "bar"]),
                            style: _normalizeStyle({ height: "".concat(barPercentage.percent, "%") })
                        }, null, 6));
                    }), 128))
                ], 544),
                _createVNode(_component_e_button, {
                    onClick: _unref(toggleRate),
                    size: "nosize",
                    type: "transparent",
                    class: "focus:outline-none"
                }, {
                    default: _withCtx(function () { return [
                        _createVNode(_component_e_icon, {
                            class: _normalizeClass(["audio-rate", [
                                    _unref(playbackRate) !== 1 && 'audio-rate__active'
                                ]]),
                            icon: "audio-rate"
                        }, null, 8, ["class"])
                    ]; }),
                    _: 1
                }, 8, ["onClick"])
            ]));
        };
    }
});
